import { useRef, useState, ComponentProps, FC } from 'react'

import Button from 'components/display/Button'
import CrossOutIcon from 'components/icons/CrossOut'

import Vimeo from '../Vimeo'

import {
  CloseButton,
  FullScreenVideo,
  FullScreenVideoHeader,
} from './VideoBanner'

type VimeoType = {
  play: () => void
  pause: () => void
}

type Props = {
  url?: string
} & Omit<ComponentProps<typeof Button>, 'onClick'>

const VideoButton: FC<Props> = ({ url, children, ...props }) => {
  const [open, setOpen] = useState(false)
  const [playing, setPlaying] = useState(false)

  const videoRef = useRef<VimeoType>()

  const handlePlayVideo = () => {
    setOpen(true)
    setTimeout(() => {
      setPlaying(true)
      videoRef.current?.play()
    }, 200)
  }

  const handleClose = () => {
    setPlaying(false)
    videoRef.current?.pause()
    setTimeout(() => {
      setOpen(false)
    }, 200)
  }

  return (
    <div style={{ position: 'relative' }}>
      {open && (
        // @ts-ignore
        <FullScreenVideo playing={playing}>
          <FullScreenVideoHeader>
            <CloseButton onClick={handleClose}>
              <CrossOutIcon />
            </CloseButton>
          </FullScreenVideoHeader>
          <Vimeo
            // @ts-ignore
            ref={videoRef}
            url={url || 'https://player.vimeo.com/video/698890830'}
          />
        </FullScreenVideo>
      )}
      <Button uppercase={false} ghost {...props} onClick={handlePlayVideo}>
        {children}
      </Button>
    </div>
  )
}

export default VideoButton
